<div class="p-4 rounded-lg" [ngClass]="{ 'bg-cyan-700 text-white': severity === 'primary', 'bg-amber-700 text-white': severity === 'warning' }">
  <ng-content></ng-content>
</div>